<div class="settings-box-shadow">
  <h3 class="no-left-margin">
    CSV Split
    <span class="font-weight-bold">Separator</span>
  </h3>
  <p>
    Choose which character splits CSV values when pasting into text fields.
  </p>

  <form [formGroup]="form" class="clearfix form">
    <vng-card variant="ghost" padding="none">
      <vng-select
        class="separator-select"
        label="Separator"
        placeholder="Separator"
        formControlName="separator"
        [options]="separatorSelectOptions"
      ></vng-select>
      <div style="display:flex; justify-content:flex-end; align-items:center; gap:8px" class="settings-card-actions">
        <button
          type="button"
          vng-button
          variant="primary"
          [disabled]="!isDirty || isSaving"
          (click)="save()"
        >
          Save
        </button>
      </div>
    </vng-card>
  </form>
</div>
